import axios from "axios";
import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Modal from "react-modal";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Button, Text } from "components";
import { useFormik } from "formik";
import * as Yup from "yup";
import Select from "react-select";

function CompanyAddressEdit() {
  const [visible, setVisible] = useState(true);
  const [active, setActive] = useState();
  const [state, setState] = useState([]);
  const [district, setDistrict] = useState([]);
  const [addresstype, setAddressType] = useState([]);
  let navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const customer_id = location.state?.id;
  const userId = sessionStorage.getItem("userId");

  const token = sessionStorage.getItem("token");
  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const [erplist, setErplist] = useState([]);
  useEffect(() => {
    // Retrieving data from sessionStorage
    const storedErplist = sessionStorage.getItem("erplist");

    if (storedErplist) {
      try {
        // Parsing the JSON string to an array of objects
        const parsedErplist = JSON.parse(storedErplist);
        setErplist(parsedErplist);
      } catch (error) {
        console.error("Error parsing JSON:", error);
      }
    }
  }, []);
  // console.log(erplist);
  const showActionColumn = erplist.some(
    (item) => item.erp_module_id == 4 && item.update
  );

  const validationSchema = Yup.object().shape({
    address_type_id: Yup.string().required("Please Select the Address Type"),
    addressline1: Yup.string().required("Address Line1 is Required"),
    addressline2: Yup.string().required("Address Line2 is Required"),
    state_id: Yup.string().required("Please Select the State"),
    district_id: Yup.string().required("Please Select the District"),
    city: Yup.string().required("City is Required"),
    pincode: Yup.string()
      .matches(/^\d{6}$/, "PIN code must be 6 digit")
      .required("PinCode is Required"),
    mobilenumber: Yup.string()
      .matches(/^[0-9]{10}$/, "Mobile Number must be exactly 10 digits")
      .required("Mobile Number is Required"),
    emailid: Yup.string()
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        "Invalid Email" // Custom error message if the pattern doesn't match
      )
      .required("Email is Required"),
    isactive: Yup.string().required("Email is Required"),
  });

  const formik = useFormik({
    initialValues: {
      id: id,
      address_type_id: "",
      addressline1: "",
      addressline2: "",
      state_id: "",
      district_id: "",
      city: "",
      pincode: "",
      mobilenumber: "",
      emailid: "",
      isactive: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      handleFormSubmit(values);
    },
  });

  useEffect(() => {
    getCustomerAddressList();
    // console.log(formik.values);
  }, [id]);

  useEffect(() => {
    stateget();
    AddressType();
    Districtget();
  }, []);

  const getCustomerAddressList = () => {
    const obj = { id: id };
    axios
      .post("/api/purple-fusion/companyaddress/get", obj, headers)
      .then((response) => {
        console.log("response.data[0]");
        const newData = response.data[0];
        setActive(response.data[0].isactive);
        console.log(newData);
        formik.setValues((prevValues) => {
          return {
            ...prevValues,
            ...newData,
          };
        });
      })
      .catch((error) => {
        navigate("*");
      });
  };
  const State_obj = {};
  const stateget = () => {
    axios
      .post("/api/purple-fusion/state/get", State_obj, headers)
      .then((response) => {
        setState(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const Address_type = {};
  const AddressType = () => {
    axios
      .post("/api/purple-fusion/addresstype/get", Address_type, headers)
      .then((response) => {
        setAddressType(response.data);
        console.log(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const District_obj = {};
  const Districtget = () => {
    axios
      .post("/api/purple-fusion/district/get", District_obj, headers)
      .then((response) => {
        setDistrict(response.data);
        // console.log(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const filteredDistricts = district.filter((resDistrict) => {
    if (resDistrict.state_id == formik.values.state_id) {
      return resDistrict;
    }
    return "";
  });

  const handleFormSubmit = (values) => {
    console.log(values);
    axios
      .put("/api/purple-fusion/companyaddress/update", values, headers)
      .then((response) => {
        console.log(response.data);
        const message = response.data.message;
        response.data.status
          ? toast.success(message, {
              autoClose: 2000,
              onClose: () => {
                setVisible(false);
                navigate(`/companysettingsall`);
              },
            })
          : toast.error(message, {
              autoClose: 2000,
              onClose: () => {},
            });
      })
      .catch((error) => {
        console.log(error);
        setVisible(false);
        navigate("*");
      });
  };

  const customStyle = {
    content: {
      width: "70%",
      height: "65%",
      margin: "auto",
      borderRadius: "10px",
    },

    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      // zIndex: 999,
    },
  };

  return (
    <>
      {showActionColumn ? (
        <div>
          <Modal isOpen={visible} style={customStyle} onRequestClose={() => {}}>
            <form onSubmit={formik.handleSubmit}>
              <div className="flex flex-1 flex-col gap-[10px] items-end justify-start md:px-5 w-full ">
                <div className="flex flex-row w-[100%] mt-2 ">
                  <div className="flex flex-row md:gap-10 items-center justify-between w-[96%] md:w-full  ml-4">
                    <Text
                      className="md:text-xl sm:text-[24px] text-base text-black-900 tracking-[0.20px]"
                      size="txtInterMedium24"
                    >
                      Update {sessionStorage.getItem("name")} Address
                    </Text>
                  </div>
                  <div className="flex flex-row items-center justify-end">
                    <Button
                      className="cursor-pointer font-medium min-w-[70px] rounded-[7px] text-center text-xl tracking-[0.20px]  active:scale-90 transition-transform duration-200"
                      shape="round"
                      color="blue_A700"
                      size="base"
                      variant="fill"
                      type="submit"
                    >
                      Save
                    </Button>
                    <Button
                      className="cursor-pointer font-medium mb-3 min-w-[70px] rounded-[7px] text-center text-xl tracking-[0.20px] mt-0"
                      shape="round"
                      color="white"
                      size="base"
                      variant="fill"
                      type="button"
                      onClick={() => {
                        setVisible(false);
                        navigate(`/companysettingsall`);
                      }}
                    >
                      ╳
                    </Button>
                  </div>
                </div>

                <div className="flex flex-col items-start justify-start w-[96%] md:w-full text-sm ">
                  <ToastContainer />
                  <div className="flex flex-col items-center justify-start  w-full ">
                    <div className="md:gap-5 gap-[75px] grid md:grid-cols-1 grid-cols-2 justify-center min-h-[auto] w-full ">
                      <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full ">
                        <Text
                          className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                          size="txtInterMedium24Black700"
                        >
                          <span className="text-black-700 font-inter font-small">
                            Address Type
                          </span>
                          <span className="text-red-A700 font-inter font-small">
                            *
                          </span>
                        </Text>
                        <Select
                          name="address_type_id"
                          options={addresstype.map((resstate) => ({
                            label: resstate.name,
                            value: resstate.id,
                          }))}
                          className="bg-white-A700 border border-gray-200_02 border-solid h-9 rounded-[5px] w-full  text-xs"
                          value={{
                            label: addresstype.find(
                              (option) =>
                                option.id === formik.values.address_type_id
                            )?.name,
                            value: formik.values.addresstype,
                          }}
                          onChange={(selectedOption) => {
                            formik.setFieldValue(
                              "address_type_id",
                              selectedOption.value
                            );
                          }}
                          onBlur={formik.handleBlur}
                          placeholder="Select Address Type"
                          isDisabled={!active}
                        />
                        {formik.touched.address_type_id &&
                        formik.errors.address_type_id ? (
                          <div className="text-red-500 text-sm">
                            {formik.errors.address_type_id}
                          </div>
                        ) : null}
                      </div>
                      <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full ">
                        <Text
                          className="md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                          size="txtInterMedium20Black700"
                        >
                          <span className="text-black-700 font-inter font-small">
                            Addressline1
                          </span>
                          <span className="text-red-A700 font-inter font-small">
                            *
                          </span>
                        </Text>
                        <input
                          name="addressline1"
                          type="text"
                          readOnly={!active}
                          placeholder=" Enter Address Line1"
                          value={formik.values.addressline1}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          className="bg-white-A700 border  border-gray-400_02 border-solid h-9 rounded-[5px] w-full text-xs"
                        ></input>
                        {formik.touched.addressline1 &&
                        formik.errors.addressline1 ? (
                          <div className="text-red-500 text-sm">
                            {formik.errors.addressline1}
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col items-center justify-start mt-4 w-full">
                    <div className="md:gap-5 gap-[75px] grid md:grid-cols-1 grid-cols-2 justify-center min-h-[auto] w-full mt-0">
                      <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full mt-0">
                        <Text
                          className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                          size="txtInterMedium20Black900"
                        >
                          <span className="text-black-700 font-inter font-small">
                            AddressLine2
                          </span>
                          <span className="text-red-A700 font-inter font-small">
                            *
                          </span>
                        </Text>
                        <input
                          name="addressline2"
                          type="text"
                          readOnly={!active}
                          placeholder=" Enter Address Line 2 "
                          value={formik.values.addressline2}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] w-full  text-xs"
                        ></input>
                        {formik.touched.addressline2 &&
                        formik.errors.addressline2 ? (
                          <div className="text-red-500 text-sm">
                            {formik.errors.addressline2}
                          </div>
                        ) : null}
                      </div>
                      <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full mt-0">
                        <Text
                          className="md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                          size="txtInterMedium20Black700"
                        >
                          <span className="text-black-700 font-inter font-small">
                            City
                          </span>
                          <span className="text-red-A700 font-inter font-small">
                            *
                          </span>
                        </Text>
                        <input
                          name="city"
                          type="text"
                          readOnly={!active}
                          placeholder=" Enter City"
                          value={formik.values.city}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          className="bg-white-A700 border  border-gray-400_02 border-solid h-9 rounded-[5px] w-full  text-xs"
                        ></input>
                        {formik.touched.city && formik.errors.city ? (
                          <div className="text-red-500 text-sm">
                            {formik.errors.city}
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col items-center justify-start w-full">
                    <div className="flex flex-col items-center justify-start mt-4 w-full">
                      <div className="md:gap-5 gap-[75px] grid md:grid-cols-1 grid-cols-2 justify-center min-h-[auto] w-full mt-0">
                        <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full mt-0">
                          <Text
                            className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                            size="txtInterMedium20Black900"
                          >
                            <span className="text-black-700 font-inter font-small">
                              Pincode
                            </span>
                            <span className="text-red-A700 font-inter font-small">
                              *
                            </span>
                          </Text>
                          <input
                            name="pincode"
                            type="number"
                            readOnly={!active}
                            placeholder=" Enter Pincode"
                            value={formik.values.pincode}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] w-full"
                          ></input>
                          {formik.touched.pincode && formik.errors.pincode ? (
                            <div className="text-red-500 text-sm">
                              {formik.errors.pincode}
                            </div>
                          ) : null}
                        </div>
                        <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full mt-0">
                          <Text
                            className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                            size="txtInterMedium20Black900"
                          >
                            <span className="text-black-700 font-inter font-small">
                              Mobile Number
                            </span>
                            <span className="text-red-A700 font-inter font-small">
                              *
                            </span>
                          </Text>
                          <input
                            name="mobilenumber"
                            type="number"
                            readOnly={!active}
                            placeholder=" Enter Mobile Number"
                            value={formik.values.mobilenumber}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] w-full  text-xs"
                          ></input>
                          {formik.touched.mobilenumber &&
                          formik.errors.mobilenumber ? (
                            <div className="text-red-500 text-sm">
                              {formik.errors.mobilenumber}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                    <div className="flex flex-col items-center justify-start mt-4 w-full">
                      <div className="md:gap-5 gap-[75px] grid md:grid-cols-1 grid-cols-2 justify-center min-h-[auto] w-full mt-0">
                        <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full mt-0">
                          <Text
                            className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                            size="txtInterMedium20Black900"
                          >
                            <span className="text-black-700 font-inter font-small">
                              Email
                            </span>
                            <span className="text-red-A700 font-inter font-small">
                              *
                            </span>
                          </Text>
                          <input
                            name="emailid"
                            readOnly={!active}
                            placeholder=" Enter Email example@gmail.com"
                            value={formik.values.emailid}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            className="bg-white-A700 border  border-gray-400_02 border-solid h-9 rounded-[5px] w-full  text-xs"
                          ></input>
                          {formik.touched.emailid && formik.errors.emailid ? (
                            <div className="text-red-500 text-sm">
                              {formik.errors.emailid}
                            </div>
                          ) : null}
                        </div>
                        <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full">
                          <Text
                            className=" md:text-[22px] text-black-900 text-center sm:text-xl tracking-[0.28px] w-auto"
                            size="txtInterMedium20Black900"
                          >
                            <span className="text-black-700 font-inter font-small">
                              Active
                            </span>
                            <span className="text-red-A700 font-inter font-small">
                              *
                            </span>
                          </Text>

                          <form>
                            <div
                              className=" text-xs"
                              style={{ display: "flex" }}
                            >
                              <input
                                className="mr-1"
                                type="radio"
                                id="yes"
                                name="isactive"
                                value="true"
                                checked={formik.values.isactive === true}
                                onChange={() => {
                                  formik.handleChange({
                                    target: {
                                      name: "isactive",
                                      value: !formik.values.isactive, // Toggle the value
                                    },
                                  });
                                }}
                              />

                              <label className="ml-1 mr-5" htmlFor="yes">
                                YES
                              </label>
                              <br />

                              <input
                                className="mr-1"
                                type="radio"
                                id="no"
                                name="isactive"
                                value="false"
                                checked={formik.values.isactive === false}
                                onChange={() => {
                                  formik.handleChange({
                                    target: {
                                      name: "isactive",
                                      value: !formik.values.isactive, // Toggle the value
                                    },
                                  });
                                }}
                              />

                              <label className="ml-2" htmlFor="no">
                                NO
                              </label>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </Modal>
        </div>
      ) : (
        <div className="flex justify-center items-center h-screen">
          <div className="text-4xl text-red-500">No Access</div>
        </div>
      )}
    </>
  );
}

export default CompanyAddressEdit;
